import { useSelector } from "react-redux";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { profileButtons } from "./profileButtons";
import { ArrowIcon } from "../../../assets/icons";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { clearAuthSession } from "../../../utils/authStorage";
import { Spring } from "../../../components/spring/spring";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { Link } from "react-router";
import { EditableAdminInfo } from "../../../components/editableAdminInfo/editableAdminInfo";

import styles from "./profilePage.module.css";

export const AdminProfilePage = () => {
    const openPage = useOpenPage();
    const { isUser, isSuperAdmin } = useSelector(state => state.status);
    const countOfCafes = useSelector(state => state.user.adminData.countOfCafes);
    const cafeId = useSelector(state => state.user.userData?.cafeId);

    const navigate = useAnimatedNavigate();
    const handleLogout = () => {
        clearAuthSession();
        navigate("/auth/login");
    }

    const [Popup, open] = useConfirmPopup(
        "Вы уверены, что хотите выйти?",
        "Все несохраненные данные будут потеряны",
        handleLogout
    );

    return (
        <>
            <EditableAdminInfo />

            <div className={styles.profile_buttons}>
                {
                    isSuperAdmin &&
                    <Button
                        type="secondary"
                        icon={<ArrowIcon />}
                        text="Панель супер-админа"
                        onClick={openPage("/superadmin")}
                    />
                }
                
                {
                    isUser && cafeId !== null &&
                    <Button
                        type="secondary"
                        icon={<ArrowIcon />}
                        text="Панель пользователя"
                        onClick={openPage("/")}
                    />
                }

                {
                    countOfCafes > 1 &&
                    <Button
                        type="secondary"
                        icon={<ArrowIcon />}
                        text="Все предприятия"
                        onClick={openPage("/admin")}
                    />
                }

                {
                    profileButtons
                        .map((data, i) =>
                            <Button
                                key={i}
                                text={data.text}
                                type={data.type}
                                icon={data.icon}
                                onClick={openPage(data.path)}
                            />
                        )
                }
            </div>

            <Spring />

            <Button 
                text="Выйти"
                type="semi_destructive"
                onClick={open}
            />

            <Link to="documents" className={styles.documents} viewTransition>Пользовательское соглашение и политика конфиденциальности</Link>

            {Popup}
        </>
    )
}
